var _rect, _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4440 -9711C-4440 -9764.02 -4397.02 -9807 -4344 -9807H12598C12651 -9807 12694 -9764.02 12694 -9711V19183C12694 19236 12651 19279 12598 19279H-4344C-4397.02 19279 -4440 19236 -4440 19183V-9711Z",
    fill: "#EEF6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4344 -9792H12598V-9822H-4344V-9792ZM12679 -9711V19183H12709V-9711H12679ZM12598 19264H-4344V19294H12598V19264ZM-4425 19183V-9711H-4455V19183H-4425ZM-4344 19264C-4388.74 19264 -4425 19227.7 -4425 19183H-4455C-4455 19244.3 -4405.3 19294 -4344 19294V19264ZM12679 19183C12679 19227.7 12642.7 19264 12598 19264V19294C12659.3 19294 12709 19244.3 12709 19183H12679ZM12598 -9792C12642.7 -9792 12679 -9755.74 12679 -9711H12709C12709 -9772.3 12659.3 -9822 12598 -9822V-9792ZM-4344 -9822C-4405.3 -9822 -4455 -9772.3 -4455 -9711H-4425C-4425 -9755.74 -4388.74 -9792 -4344 -9792V-9822Z",
    fill: "#5DA5D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-2210 -449C-2210 -484.346 -2181.35 -513 -2146 -513H7078C7113.35 -513 7142 -484.346 7142 -449V1831C7142 1866.35 7113.35 1895 7078 1895H-2146C-2181.35 1895 -2210 1866.35 -2210 1831V-449Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2146 -503H7078V-523H-2146V-503ZM7132 -449V1831H7152V-449H7132ZM7078 1885H-2146V1905H7078V1885ZM-2200 1831V-449H-2220V1831H-2200ZM-2146 1885C-2175.82 1885 -2200 1860.82 -2200 1831H-2220C-2220 1871.87 -2186.87 1905 -2146 1905V1885ZM7132 1831C7132 1860.82 7107.82 1885 7078 1885V1905C7118.87 1905 7152 1871.87 7152 1831H7132ZM7078 -503C7107.82 -503 7132 -478.823 7132 -449H7152C7152 -489.869 7118.87 -523 7078 -523V-503ZM-2146 -523C-2186.87 -523 -2220 -489.869 -2220 -449H-2200C-2200 -478.823 -2175.82 -503 -2146 -503V-523Z",
    fill: "#5DA5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_44749)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -350,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -350,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "url(#paint0_linear_378_44749)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_378_44749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-310 3.8147e-06C-310 -16.5685 -296.569 -30 -280 -30H74V394C74 410.568 60.5685 424 44 424H-280C-296.569 424 -310 410.568 -310 394V3.8147e-06Z",
    fill: "#EFF9F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#A0DAC9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_378_44749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8266 21.1376H22.8266V18.1751C22.8266 17.7251 22.4516 17.3501 21.9641 17.3501C21.5141 17.3501 21.1391 17.7251 21.1391 18.2126V21.1751H18.1766C17.7266 21.1751 17.3516 21.5501 17.3516 22.0376C17.3516 22.4876 17.7266 22.8626 18.2141 22.8626H21.1766V25.8251C21.1766 26.2751 21.5516 26.6501 22.0391 26.6501C22.4891 26.6501 22.8641 26.2751 22.8641 25.7876V22.8251H25.8266C26.2766 22.8251 26.6516 22.4501 26.6516 21.9626C26.6516 21.5126 26.2766 21.1376 25.8266 21.1376Z",
    fill: "#306153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0008 10.675C15.7383 10.675 10.6758 15.7375 10.6758 22C10.6758 28.2626 15.7758 33.3625 22.0383 33.3625C28.3008 33.3625 33.4008 28.2626 33.4008 22C33.3633 15.7375 28.2633 10.675 22.0008 10.675ZM22.0008 31.675C16.6758 31.675 12.3633 27.325 12.3633 22C12.3633 16.675 16.6758 12.3625 22.0008 12.3625C27.3258 12.3625 31.6758 16.675 31.6758 22C31.6758 27.325 27.3258 31.675 22.0008 31.675Z",
    fill: "#306153"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_44749",
    x1: 290,
    y1: -367,
    x2: 290,
    y2: 165.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F7FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -350,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 861,
    fill: "white",
    transform: "translate(-350 -317)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusIcon);
export default __webpack_public_path__ + "static/media/CirclePlusIcon.e03a3afc94edc3eea9e71543e988eab7.svg";
export { ForwardRef as ReactComponent };